import { camelCase } from 'lodash';

import { exportedEditablePromptToFormValues } from './editablePrompt.ts';
import { VOICE_AGENT_FORM_DEFAULT_VALUES, VoiceAgentFormData } from '../components/ConfigSteps.tsx';

// the form holds these numbers as strings (free-text inputs)
const STRING_NUMBER_FIELDS: (keyof VoiceAgentFormData)[] = [
    'webCallDailyCap',
    'webCallCooldownSeconds',
    'callerVerificationMaxAttempts',
];

const selection = (raw: any) =>
    raw ? { headerFields: raw.header_fields || [], lineItemFields: raw.line_item_fields || [] } : null;

// Maps a voice agent export (snake_case model fields, as exportVoiceAgentConfig writes them) onto the wizard's
// form values: everything the file carries and the form knows is taken over as is.
export const voiceAgentExportToFormValues = (data: Record<string, any>): Partial<VoiceAgentFormData> => {
    const values: Record<string, unknown> = {};
    for (const [key, raw] of Object.entries(data)) {
        const formKey = camelCase(key) as keyof VoiceAgentFormData;
        if (formKey in VOICE_AGENT_FORM_DEFAULT_VALUES && raw != null) values[formKey] = raw;
    }
    if (Array.isArray(data.web_call_allowed_prefixes)) {
        values.webCallAllowedPrefixes = data.web_call_allowed_prefixes.join(', ');
    }
    for (const field of STRING_NUMBER_FIELDS) {
        if (values[field] != null) values[field] = String(values[field]);
    }
    if (data.default_channel_config) {
        values.defaultChannels = {
            orderChannelId: data.default_channel_config.ORDER || '',
            rfqChannelId: data.default_channel_config.REQUEST_FOR_QUOTATION || '',
        };
    }
    if (data.editable_prompt) {
        values.editablePrompt = exportedEditablePromptToFormValues(data.editable_prompt);
    }
    if (data.document_field_config) {
        values.documentFields = {
            order: selection(data.document_field_config.ORDER),
            rfq: selection(data.document_field_config.REQUEST_FOR_QUOTATION),
        };
    }
    return values as Partial<VoiceAgentFormData>;
};
